import api from '@/api'


export default {
  namespaced: true,
  state: {
    notifications: []
  },
  getters: {
    lastId(state, getters) {
      if (!state.notifications.length) {
        return null
      }
      return getters['sorted'][0].id
    },
    sorted(state) {
      return state.notifications.sort((a, b) => {
        if (a.id < b.id) {
          return 1
        }
        if (a.id > b.id) {
          return -1
        }
        return 0
      })
    },
    count(state) {
      return state.notifications.filter(n => {
        return !n.seen
      }).length
    }
  },
  mutations: {
    notifications_loaded(state, data) {
      state.notifications = state.notifications.concat(data)
    },
    seen_all(state) {
      state.notifications.forEach(n => {
        n.seen = 1
      })
    },
    clear(state) {
      state.notifications = []
    }
  },
  actions: {
    async clear(context) {
      await api({
        method: "GET",
        url: "/account/notifications/clear"
      })
      context.commit('clear')
    },
    async seen_all(context) {
      await api({
        method: "GET",
        url: "/account/notifications/seen"
      })
      context.commit('seen_all')
    },
    async load(context) {
      let notifications = await api({
        method: "GET",
        url: `/account/notifications`,
        params: {
          last_id: context.getters['lastId']
        }
      })
      context.commit('notifications_loaded', notifications)
    }
  }
}
